import { useHeader } from "../../../../context/HeaderContext";
import BottomMenu from "../../../../components/Dashboard/BottomMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  useGetPaymentInfoQuery,
  useSubmitPremiumPaymentProofMutation,
  useSubmitPremiumPlusPaymentProofMutation,
} from "../../../../services/addMoneyApi";
import {
  IoCopyOutline,
  IoWarningOutline,
  IoAlertCircle,
} from "react-icons/io5";
import { Notification } from "../../../../components/ToastNotification";
import InlineRefreshIndicator from "../../../../components/InlineRefreshIndicator";
import "./paymentMethods.css";
import { useGetSpecificUserPremium_PlusAmountQuery } from "../../../../services/userApi";
import { useGetAllPremiumCouponQuery } from "../../../../services/addMoneyApi";
import ViewMore from "./ViewMore";
import BottomSheetModal from "./BottomSheetModal";
import { AiOutlineCloseCircle } from "react-icons/ai";

const PremiumUSDTTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { amount } = location.state || {};
  const { data: premiumplusamount } =
    useGetSpecificUserPremium_PlusAmountQuery();

  const discountedPremiumPlusPrice =
    premiumplusamount?.new_price_premium_plus ||
    premiumplusamount?.old_price_premium_plus;

  const isPremiumPlus =
    parseFloat(amount) === parseFloat(discountedPremiumPlusPrice);

  const {
    data: getcoupon,
    isLoading: loading,
    isError,
  } = useGetAllPremiumCouponQuery({});

  console.log("coupons", getcoupon);

  const coupons = getcoupon?.coupons || [];

  const [transactionId, setTransactionId] = useState("");
  const [singleFile, setSingleFile] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [visible, setVisible] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Slider navigation
  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredCoupons.length - 1 : prev - 1
    );
  };
  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === filteredCoupons.length - 1 ? 0 : prev + 1
    );
  };

  // Filtered coupons (Premium or PremiumPlus)
  const filteredCoupons = coupons.filter(
    (coupon) =>
      !coupon.isHide &&
      (isPremiumPlus
        ? coupon.couponFor === "PremiumPlus"
        : coupon.couponFor === "Premium")
  );

  const { data: paymentInfo, isLoading: paymentInfoLoading } =
    useGetPaymentInfoQuery();
  //  const { setScreenName } = useHeader();
  //    useEffect(() => {
  //        setScreenName("USDT Details");
  //        return () => {
  //          setScreenName(null);
  //        };
  //      }, []);
  const [submitPremiumPaymentProof] = useSubmitPremiumPaymentProofMutation();

  const discountedPrice = appliedCoupon ? amount - appliedCoupon.value : amount;

  const handleSubmit = async () => {
    if (singleFile) {
      try {
        setFileUploading(true);
        const formData = new FormData();
        formData.append("file", singleFile);
        formData.append("transactionId", transactionId);
        formData.append("payment_mode", "usdt_payment");
        formData.append("appliedCoupon", appliedCoupon?.couponId || null);
        formData.append("amount", amount);

        const response = await submitPremiumPaymentProof(formData);

        if (response.error) {
          Notification(response.error.data.message, "error");
        } else {
          Notification(
            `Request for Premium plan sent successfully`,
            "success"
          );
          setTransactionId("");
          setSingleFile(null);
        }
      } catch (error) {
        console.error("Error details:", error);
        Notification("An error occurred during submission", "error");
      } finally {
        setFileUploading(false);
      }
    } else {
      Notification("Payment proof image is required", "error");
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Notification("USDT Wallet Address Copied", "success");
  };

  const selectFile = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 3 * 1024 * 1024) {
      alert("Maximum size of images is 3 MB");
    } else {
      setSingleFile(file);
    }
  };

  return (
    // <div className="tpu__premium__wrapper layoutContainer">
    <div className="layoutContainer">
      <div className="tpu__premium__section__area">
        <div className="tpu-premium-upi-scroll-view">
          <div className="tpu-premium-upi-content">
            <div className="tpu-premium-upi-card">
              <div className="tpu-premium-usdt-card-row">
                <p className="tpu-premium-upi-card-label">
                  USDT Wallet Address:
                </p>
                <IoCopyOutline
                  size={18}
                  color={"#007aff"}
                  style={{ cursor: "pointer", marginTop: "2px" }}
                  onClick={() =>
                    copyToClipboard(
                      paymentInfo?.data?.data?.payment_info[0][2]?.bnb_usdt_info
                        ?.bnb_usdt || ""
                    )
                  }
                />
              </div>

              <p className="tpu-premium-usdt-card-value">
                {paymentInfo?.data?.data?.payment_info[0][2]?.bnb_usdt_info
                  ?.bnb_usdt || "N/A"}
              </p>
            </div>

            <div className="tpu-premium-upi-input-container">
              <label className="tpu-premium-upi-label">Amount (USDT)</label>
              <input
                className="tpu-premium-upi-input disabled-input"
                value={(discountedPrice / 100).toFixed(3)}
                readOnly
              />
            </div>

            <div className="tpu-premium-upi-input-container">
              <label className="tpu-premium-upi-label">Hash Id</label>
              <input
                className="tpu-premium-upi-input"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                placeholder="Enter transaction id"
              />
            </div>

            {appliedCoupon ? (
              <div className="applied-coupon-box">
                <div className="remove-applied-coupon">
                  <button
                    className="remove-coupon"
                    onClick={() => setAppliedCoupon(null)}
                  >
                    <AiOutlineCloseCircle size={18} color="black" />
                  </button>
                </div>
                <div className="applied-coupon-box-inside">
                  <div className="info">
                    <span className="icon">✓</span>
                    <div className="textContainer">
                      <span className="title">Coupon code applied</span>
                      <span className="subtitleText">
                        {appliedCoupon?.shortDescription}! - Unlock
                      </span>
                    </div>
                    <button className="couponTextButton">
                      <span className="couponTextButtonText">
                        {appliedCoupon.couponText}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <span
                style={{
                  alignSelf: "center",
                  marginLeft: "60px",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                Got a coupon code?{" "}
                <span
                  onClick={() => {
                    setVisible(true);
                  }}
                  style={{ color: "purple", cursor: "pointer" }}
                >
                  Apply
                </span>
              </span>
            )}

            <div className="couponBox">
              {/* Coupon Slider */}
              {!loading && (
                <div className="coupon-section">
                  {isError || filteredCoupons.length === 0 ? (
                    <p style={{ alignSelf: "flex-start", marginLeft: "22px" }}>
                      No Coupons Available
                    </p>
                  ) : (
                    <>
                      <div className="slider-wrapper">
                        <button className="nav-btn prev" onClick={handlePrev}>
                          &#10094;
                        </button>

                        <div
                          className="coupon-slider"
                          style={{
                            transform: `translateX(-${currentIndex * 100}%)`,
                          }}
                        >
                          {filteredCoupons.map((coupon) => (
                            <div
                              key={coupon._id}
                              className="coupon-card-container"
                            >
                              <div
                                className={` coupon-card ${
                                  appliedCoupon?.couponId === coupon.couponId
                                    ? "coupon-card-applied"
                                    : ""
                                }`}
                              >
                                <div className="coupon-content">
                                  <span>
                                    <span
                                      className="coupon-code"
                                      style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {coupon.couponText}
                                    </span>
                                  </span>
                                  <button
                                    onClick={() => setAppliedCoupon(coupon)}
                                    className={`apply-btn ${
                                      appliedCoupon?.couponId ===
                                      coupon.couponId
                                        ? "applied"
                                        : ""
                                    }`}
                                    disabled={
                                      appliedCoupon?.couponId ===
                                      coupon.couponId
                                    }
                                  >
                                    {appliedCoupon?.couponId ===
                                    coupon.couponId ? (
                                      <strong
                                        style={{
                                          backgroundColor: "#28a745",
                                          // border: "1px solid gray",
                                        }}
                                      >
                                        Applied
                                      </strong>
                                    ) : (
                                      <strong>APPLY</strong>
                                    )}
                                  </button>
                                </div>

                                <div className="DescriptionContainer">
                                  <p className="coupon-shortDescription">
                                    {coupon.title}
                                  </p>
                                  <p className="coupon-description">
                                    Get ${(coupon.value / 100).toFixed(4)} Points
                                    OFF
                                  </p>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpen(true);
                                      setSelectedCoupon(coupon);
                                    }}
                                    className={`ViewMore ${
                                      appliedCoupon?.couponId ===
                                      coupon.couponId
                                        ? "ViewMore-applied"
                                        : ""
                                    }`}
                                  >
                                    View More
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <button className="nav-btn next" onClick={handleNext}>
                          &#10095;
                        </button>
                      </div>

                      <div className="dot-container">
                        {filteredCoupons.map((_, idx) => (
                          <span
                            key={idx}
                            className={`dot ${
                              idx === currentIndex ? "active" : ""
                            }`}
                            onClick={() => setCurrentIndex(idx)}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>

            <div className="tpu-premium-upi-input-container">
              <label className="tpu-premium-upi-label">Upload File</label>
              <button
                className="file-picker-btn"
                onClick={() => document.getElementById("upload-file").click()}
              >
                <input
                  type="file"
                  id="upload-file"
                  onChange={selectFile}
                  style={{ display: "none" }}
                />
                <span>
                  {singleFile?.name
                    ? singleFile.name.slice(0, 15)
                    : "Choose File"}
                </span>
              </button>
            </div>

            {singleFile && (
              <div className="file-preview">
                <img
                  src={URL.createObjectURL(singleFile)}
                  alt="File preview"
                  className="file-preview__image"
                />
                <div className="file-preview__info">
                  <span>{singleFile?.name}</span>
                </div>
              </div>
            )}

            <div className="tpu-premium-upi-button-container">
              <button
                className="tpu-premium-upi-button prev"
                onClick={() => navigate(-1)}
              >
                Prev
              </button>
              <button
                className={`tpu-premium-upi-button submit ${
                  !transactionId || !singleFile || fileUploading
                    ? "disabled"
                    : ""
                }`}
                disabled={!transactionId || !singleFile || fileUploading}
                onClick={handleSubmit}
              >
                {fileUploading ? "Uploading..." : "Submit"}
              </button>
            </div>

            <ViewMore
              open={open}
              setOpen={setOpen}
              coupon={selectedCoupon}
              paymentType={"USDT"}
              setSelectedCoupon={setSelectedCoupon}
              appliedCoupon={appliedCoupon}
              setAppliedCoupon={setAppliedCoupon}
            ></ViewMore>
            <BottomSheetModal
              visible={visible}
              isPremiumPlus={isPremiumPlus}
              onClose={() => {
                setVisible(false);
              }}
              allCoupons={coupons}
              setAppliedCoupon={setAppliedCoupon}
            ></BottomSheetModal>

            <div className="disclaimer-container">
              <div className="disclaimer-gradient">
                <div className="disclaimer-header">
                  <IoWarningOutline className="warning-icon" />
                  <span className="disclaimer-title">Disclaimer</span>
                </div>
                <div className="disclaimer-content">
                  <div className="disclaimer-item">
                    <div className="bullet-container">
                      <IoAlertCircle className="alert-icon" />
                    </div>
                    <span className="disclaimer-text">
                      Only send{" "}
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/14446/14446253.png"
                        alt="Tether"
                        className="tether-icon"
                      />{" "}
                      Tether USD (BEP20) assets to this address. Other assets
                      will be lost forever.
                    </span>
                  </div>
                  <div className="disclaimer-item">
                    <div className="bullet-container">
                      <IoAlertCircle className="alert-icon" />
                    </div>
                    <span className="disclaimer-text">
                      Network allowance only BNB Smart Chain(BEP20).
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <BottomMenu /> */}
    </div>
    // </div>
  );
};

export default PremiumUSDTTransfer;
